module.exports = __webpack_public_path__ + "img/kx.3e698f34.gif";